import { render, staticRenderFns } from "./CallbotAnalytics.vue?vue&type=template&id=72f991eb&scoped=true"
import script from "./CallbotAnalytics.vue?vue&type=script&lang=ts"
export * from "./CallbotAnalytics.vue?vue&type=script&lang=ts"
import style0 from "./CallbotAnalytics.vue?vue&type=style&index=0&id=72f991eb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f991eb",
  null
  
)

export default component.exports